<template>
  <div id="app">
    <div>
      <Header-el></Header-el>
      <div class style="position: absolute;"></div>
      <div class="user-space">
        <MyNav-el></MyNav-el>
        <article class="user-article">
          <div class="support-space">
            <div id="supportlistModule" class="order-module">
              <div class="module-header">
                <span class="module-name">支持记录</span>
                <span class="module-tip">如有问题请拨打客服热线：13919392393（8:00-24:00）</span>
              </div>
              <div class="module-tab">
                <ul class="nav">
                  <li :class="'nav-tab '+(orderFilter.Status==null?'active':'')">
                    <a href="javascript:void(0)" v-on:click="orderFilter.Status=null;loadMyOrder()" class="nav-inner">
                      <span class="nav-name">全部</span>
                    </a>
                  </li>
                  <li :class="'nav-tab '+(orderFilter.Status!=null&&orderFilter.Status.Value==1?'active':'')">
                    <a href="javascript:void(0)" v-on:click="orderFilter.Status={'Value':[1]};loadMyOrder()" class="nav-inner">
                      <span class="nav-name">待付款</span>
                    </a>
                  </li>
                  <li :class="'nav-tab '+(orderFilter.Status!=null&&orderFilter.Status.Value==2?'active':'')">
                    <a href="javascript:void(0)" v-on:click="orderFilter.Status={'Value':[2]};loadMyOrder()" class="nav-inner">
                      <span class="nav-name">已付款</span>
                    </a>
                  </li>
                  <li :class="'nav-tab '+(orderFilter.Status!=null&&orderFilter.Status.Value==3?'active':'')">
                    <a href="javascript:void(0)" v-on:click="orderFilter.Status={'Value':[3]};loadMyOrder()" class="nav-inner">
                      <span class="nav-name">已取消</span>
                    </a>
                  </li>
                  <li :class="'nav-tab '+(orderFilter.Status!=null&&orderFilter.Status.Value==4?'active':'')">
                    <a href="javascript:void(0)" v-on:click="orderFilter.Status={'Value':[4]};loadMyOrder()" class="nav-inner">
                      <span class="nav-name">已完成</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="order-list">
                <div>
                  <div v-for="(order,index) in orderResult.Results" v-bind:key="index">
                    <section class="support-order">
                      <div class="order-summary">
                        <div class="order-hd">
                          <span>{{order.CreateTime}}</span>
                          <label class="order-state"></label>
                        </div>
                        <div class="order-bd clearfix cursor-pointer">
                          <div class="prj-cover">
                            <img
                              :src="order.ImageUrl"
                            >
                          </div>
                          <div class="prj-content">
                            <h5 class="prj-title">{{order.ProjectName}}</h5>
                            <div class="prj-summary">
                              {{order.ProfitTitle}}
                              <!---->
                            </div>
                            <div class="order-box">
                              <strong class="order-price">{{order.Amount}}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="order-ft clearfix">
                        <div class="order-ftbox">
                          <span>
                            合计：
                            <strong>{{order.Amount}}</strong>
                          </span>
                          <!---->
                          <a
                            :href="'/detail/'+order.ID"
                            class="ksui-btn ksbtn-green-empty detail-btn"
                          >查看订单详情</a>
                        </div>
                      </div>
                    </section>
                  </div>

                  <div class="page-box clearfix">
                    <div data-v-702d7f8b class="page-nav">
                      <ul data-v-702d7f8b>
                        <li data-v-702d7f8b :class="(orderFilter.Pager.PageNumber==index+1?'active':'')" v-for="(page,index) in orderResult.PageCount" v-bind:key="index">
                          <a data-v-702d7f8b v-on:click="orderFilter.Pager.PageNumber=index+1;loadMyOrder()">{{index+1}}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!---->
                  <!---->
                  <!---->
                  <!---->
                </div>
                <!---->
              </div>
            </div>
          </div>
        </article>
      </div>
      <ul id="nav-share" class="nav-share" style="bottom: 100px; right: 100px;">
        <li class="s-phone">
          <a href="javascript:;"></a>
          <div class="s-phone-hover">
            <p class="sph-t">客服热线（10:00-20:00）</p>
            <p class="sph-p">13919392393</p>
          </div>
        </li>
        <li class="s-wechat">
          <a href="javascript:;"></a>
          <div class="s-wechat-hover">
            <img
              width="100%"
              height="100%"
              src="http://images.kaishiba.com/pc_bottom_qrcode.png"
              alt="wechat"
            >
          </div>
        </li>
        <li class="s-sina">
          <a href="//weibo.com/beginow" target="_blank"></a>
        </li>
        <!---->
      </ul>
    </div>
  </div>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
import MyNav from "../components/mynav";

export default {
  name: "app",
  components: {
    "Header-el": Header,
    "Footer-el": Footer,
    "MyNav-el": MyNav
  },
  data() {
    return {
      orderFilter:{Status:null,Pager:{PageNumber:1,PageSize:10}},
      orderResult: []
    };
  },
  methods: {
    loadMyOrder: function() {
      console.log(this.orderFilter);
      fetch(host+"/api/project/orders", {
        method: "Post",
        mode: "cors",
        credentials: "include",
        body: JSON.stringify(this.orderFilter),
        headers: {
          "Access-Token": localStorage.getItem("token")
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data.Success) {
            this.orderResult = data.Data;
          }
        })
        .catch(ex => console.log(ex));
    },
    filterload(){

    }
  },
  created() {
    this.loadMyOrder();
  }
};
</script>

<style scoped>
@import url("../css/myindex.css");

.prj-cover {
  float: left;
  margin-right: 20px;
}
.prj-cover img {
  width: 80px;
  height: 80px;
}
.prj-content {
  overflow: hidden;
  position: relative;
}
.prj-group {
  color: #999;
}
.prj-title {
  margin-bottom: 10px;
}
.prj-summary {
  margin-bottom: 15px;
}
.order-summary {
  border: 1px solid #e1e1e1;
}
.order-hd {
  border-bottom: 1px solid #e1e1e1;
}
.order-hd {
  height: 38px;
  line-height: 38px;
  padding: 0 20px;
  background: #fafafa;
}
.order-box {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
}
.order-cont {
  color: #999;
}
.order-price {
  font-size: 24px;
}
.order-bd {
  padding: 20px;
}
.order-state {
  float: right;
  color: #ee685d;
  font-weight: 500;
}

.order-ft {
  padding: 15px 20px;
  border: 1px solid #e1e1e1;
  border-top: none;
}
.order-ftbox {
  float: right;
  color: #999;
}
.order-ftbox strong {
  color: #333;
  font-size: 16px;
}
.detail-btn {
  margin: 0 0 0 20px;
  height: 30px;
  width: auto;
  padding: 0 15px;
  font-weight: 500;
  font-size: 12px;
  line-height: 30px;
  cursor: pointer;
}
</style>
